import { Component, ChangeDetectionStrategy, Input, EventEmitter, Output, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PreMedia } from '@app/features/pre-media/pre-media.adapter';
import { ArticleModel } from '@modules/article/models/article.model';
import { PressKit } from '@modules/content-api/adapter/press-kit.adapter';
import { MediaModelType } from '@modules/media/models/media.model';
import { IcsModalComponent } from '@modules/shared/modal/ics-modal/ics-modal.component';
import { DialogService } from '@modules/shared/services/dialog.service';
import { LightboxService } from '@modules/shared/services/lightbox.service';
import { WindowService } from '@modules/shared/services/window.service';
import { ActionIcons, ButtonItem } from '@modules/ui/action-container/action-container.component';
import { MetaItemInterface } from '@modules/ui/meta-items/meta-items.component';

import { PressKitCardWrapperService } from './press-kit-card-wrapper.service';

@Component({
  selector: 'mb-press-kit',
  templateUrl: './press-kit.component.html',
  styleUrls: ['./press-kit.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PressKitComponent implements OnInit {
  @Input() pressKit!: PressKit;
  @Input() defaultActions!: ButtonItem[];
  @Input() sectionActions: ButtonItem[] = [];
  @Input() pressKitActions: ButtonItem[] = [];

  @Input() preMedia?: PreMedia;

  @Output() actionClick = new EventEmitter<{ action: ActionIcons; resource: any }>();

  public showAllPressKitArticles: boolean = false;

  constructor(
    private lightboxService: LightboxService,
    private windowService: WindowService,
    private pressKitCardWrapperService: PressKitCardWrapperService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private dialogService: DialogService
  ) {}

  ngOnInit(): void {
    this.showAllPressKitArticles = this.pressKitCardWrapperService.isCardWrapperOpened(this.pressKit.id);
  }

  public openMediaGallery(list: MediaModelType[], index: number): void {
    this.lightboxService.openMediaGallery(list, index, this.getCurrentRelationship(), this.preMedia);
  }

  public scrollToAnchor(metaItem: MetaItemInterface): void {
    this.windowService.scrollToId(metaItem.data);
  }

  public goToPressArticlePage(article: ArticleModel): void {
    this.router.navigate(['article', article.id], { relativeTo: this.activatedRoute });
  }

  public onTogglePressKitArticlesWrapper(showAll: boolean): void {
    this.showAllPressKitArticles = showAll;
    this.pressKitCardWrapperService.setIsCardWrapperOpened(this.pressKit.id, this.showAllPressKitArticles);
  }

  public openIcsModal() {
    const ref = this.dialogService.open({
      component: IcsModalComponent,
      inputs: {
        icsLink: this.preMedia?.ics_link,
      },
      outputs: {
        confirm: () => {
          ref.close();
          // download ics file
        },
        cancel: () => {
          ref.close();
        },
      },
    });
  }

  private getCurrentRelationship() {
    return {
      label: 'CONNECTED_PRESS_KIT',
      text: this.pressKit.title,
      link: {
        url: this.preMedia ? `/pre-media/${this.preMedia.id}` : `/press-kit/${this.pressKit.id}`,
      },
    };
  }
}
